import axios from "axios";

export const CONDICION_FISCAL_URL = `CondicionFiscal`;

export const condicionFiscalServices = {
  lookup: () => {
    return axios.get<any>(`${CONDICION_FISCAL_URL}/Lookup`);
  },
};
